export const welcomeStandalone = {
  id: 'welcomeStandalone',
  name: _TL_('Welcome'),
  route: 'Welcome',
  checkPermission: permissions => permissions.dynamic.WebpackifyPhase2Customer,
};
